import React from "react";
import { motion } from "framer-motion";

/**
 * Фиксированный бургер из 3 полосок.
 * — не превращается в крестик
 * — сохраняет класс `toggle-btn` для click-outside
 * — визуально «лежит на хедере»
 */
const ToggleButton = ({ open = false, onClick, className = "" }) => {
  const label = open ? "Закрыть меню" : "Открыть меню";

  return (
    <button
      type="button"
      aria-label={label}
      aria-expanded={open}
      onClick={onClick}
      className={`toggle-btn fixed top-4 left-4 z-[60]
        inline-grid place-items-center
        h-12 w-12 rounded-2xl
        bg-black/40 backdrop-blur-md
        border border-white/15
        shadow-[0_10px_30px_rgba(0,0,0,.35)]
        hover:bg-black/50 hover:border-white/25
        focus:outline-none focus:ring-2 focus:ring-violet-500/60
        transition-colors ${className}`}
    >
      {/* Контейнер линий */}
      <motion.span
        aria-hidden="true"
        className="relative h-5 w-6"
        initial={false}
        whileTap={{ scale: 0.96 }}
      >
        {/* верхняя */}
        <span
          className="absolute left-0 top-0 w-full h-[2px] rounded bg-white"
        />
        {/* средняя */}
        <span
          className="absolute left-0 top-1/2 w-full h-[2px] rounded bg-white"
          style={{ transform: "translateY(-50%)" }}
        />
        {/* нижняя */}
        <span
          className="absolute left-0 bottom-0 w-full h-[2px] rounded bg-white"
        />
      </motion.span>

      {/* мягкое свечение/обводка */}
      <span
        aria-hidden="true"
        className="pointer-events-none absolute inset-0 rounded-2xl ring-1 ring-inset ring-white/10"
      />
      <span
        aria-hidden="true"
        className="pointer-events-none absolute -inset-1 rounded-2xl bg-violet-600/0 blur-lg transition
                   hover:bg-violet-600/10"
      />
    </button>
  );
};

export default ToggleButton;
